import React, { memo } from "react";

const CallDetailPanelLoader = () => (
  <div className="callDetailPanelLoader">
    <div className="callDetailPanelLoader__header">
      <div className="callDetailPanelLoader__headerTop">
        <div className="callDetailPanelLoader__nameBlock">
          <span className="callDetailPanelLoader__name linear-background" />
          <div className="callDetailPanelLoader__metaRow">
            <span className="callDetailPanelLoader__metaChip linear-background" />
            <span className="callDetailPanelLoader__metaChip linear-background" />
            <span className="callDetailPanelLoader__metaChip linear-background" />
          </div>
        </div>
        <span className="callDetailPanelLoader__outcome linear-background" />
      </div>
      <span className="callDetailPanelLoader__audioBar linear-background" />
    </div>

    <div className="callDetailPanelLoader__tabs">
      <span className="callDetailPanelLoader__tab linear-background" />
      <span className="callDetailPanelLoader__tab linear-background" />
      <span className="callDetailPanelLoader__tab linear-background" />
    </div>

    <div className="callDetailPanelLoader__body">
      <span className="callDetailPanelLoader__sectionLabel linear-background" />
      <span className="callDetailPanelLoader__textBlock linear-background" />
      <span className="callDetailPanelLoader__textBlock linear-background" />
      <span className="callDetailPanelLoader__textBlockShort linear-background" />

      <div className="callDetailPanelLoader__divider" />

      <span className="callDetailPanelLoader__sectionLabel linear-background" />
      <div className="callDetailPanelLoader__grid">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="callDetailPanelLoader__gridItem">
            <span className="callDetailPanelLoader__gridLabel linear-background" />
            <span className="callDetailPanelLoader__gridValue linear-background" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default memo(CallDetailPanelLoader);
